<div class="admin-tool-panel">
  <mat-tab-group>
    <mat-tab label="Users">
      <app-user-management></app-user-management>
    </mat-tab>
    <mat-tab label="Table Data">
      <div class="admin-panel-table-data">
        <h3>Add new product tag</h3>
        <div class="add-tag-grid">
          <mat-form-field class="example-form-field" appearance="fill">
            <mat-label>New Tag</mat-label>

            <input matInput type="text" (input)="onTagValueChanged($event)" [formControl]="tagsCtrl" [(ngModel)]="newTag" [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectExistTag($event)">
              <mat-option *ngFor="let tag of tagsList | async" [value]="tag.name">
                {{tag.name}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <div class="input-action-btn">
            <button (click)="addTag()" [disabled]="allowAddTag === false" mat-raised-button color="primary">Add</button>
            <button (click)="deleteTag()" [disabled]="allowDeleteTag === false" mat-raised-button color="warn">Delete</button>
          </div>
        </div>
        <hr>

        <h3>Add new shipping tags</h3>
        <div class="add-type-grid">
          <mat-form-field class="example-form-field" appearance="fill">
            <mat-label>New Shipping Tag</mat-label>
            <input matInput type="text" (input)="onShippingTagValueChanged($event)" [formControl]="shippingTagsCtrl" [(ngModel)]="newShippingTag" [matAutocomplete]="autoShippingTag">
                  <mat-autocomplete #autoShippingTag="matAutocomplete" (optionSelected)="selectExistShippingTag($event)">
                    <mat-option *ngFor="let tag of shippingTagsList | async" [value]="tag.name">
                      {{tag.name}}
                    </mat-option>
                  </mat-autocomplete>
          </mat-form-field>

          <div class="input-action-btn">
            <button (click)="addShippingTag()" [disabled]="allowAddShippingTag === false" mat-raised-button color="primary">Add</button>
            <button (click)="deleteShippingTag()" [disabled]="allowDeleteShippingTag === false" mat-raised-button color="warn">Delete</button>
          </div>
        </div>
        <hr>

        <h3>Add new product type</h3>
        <div class="add-type-grid">
          <mat-form-field class="example-form-field" appearance="fill">
            <mat-label>New Type</mat-label>
            <input matInput type="text" (input)="onTypeValueChanged($event)" [formControl]="typesCtrl" [(ngModel)]="newType" [matAutocomplete]="autoType">
            <mat-autocomplete #autoType="matAutocomplete" (optionSelected)="selectExistType($event)">
              <mat-option *ngFor="let type of typesList | async" [value]="type.name">
                {{type.name}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <div class="input-action-btn">
            <button (click)="addType()" [disabled]="allowAddType === false" mat-raised-button color="primary">Add</button>
            <button (click)="deleteType()" [disabled]="allowDeleteType === false" mat-raised-button color="warn">Delete</button>
          </div>
        </div>
        <hr>

        <h3>Add new product brand</h3>
        <div class="add-brand-grid">
          <mat-form-field class="example-form-field" appearance="fill">
            <mat-label>New Brand</mat-label>
            <input matInput type="text" (input)="onBrandValueChanged($event)" [formControl]="brandsCtrl" [(ngModel)]="newBrandName" [matAutocomplete]="autoBrand">
            <mat-autocomplete #autoBrand="matAutocomplete" (optionSelected)="selectExistBrand($event)">
              <mat-option *ngFor="let brand of brandsList | async" [value]="brand.name">
                {{brand.name}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <div class="input-action-btn">
            <button (click)="addBrand()" [disabled]="allowAddBrand === false" mat-raised-button color="primary">Add</button>
            <button (click)="deleteBrand()" [disabled]="allowDeleteBrand === false" mat-raised-button color="warn">Delete</button>
          </div>
          <div class="brand-checkbox-group">
            <mat-checkbox [(ngModel)]="gmcBHSChecked" color="primary">GMC BHS</mat-checkbox>
            <mat-checkbox [(ngModel)]="gmcMWSChecked" color="primary">GMC MDW</mat-checkbox>
          </div>
        </div>
        <hr>

        <h3>ASM Tags</h3>
        <div class="add-type-grid">
          <mat-form-field appearance="fill">
            <mat-label>ASM Tags</mat-label>
            <mat-select [formControl]="asmTagFormControl">
              <mat-option *ngFor="let tag of asmTags" [value]="tag.value">
                {{tag.viewValue}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!--    <button [disabled]="true" mat-raised-button color="warn">Add</button>-->
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Scheduled Events">
      <app-scheduled-events></app-scheduled-events>
    </mat-tab>
    <mat-tab label="Bulk Pricing">
      <app-bulk-pricing-models></app-bulk-pricing-models>
    </mat-tab>
    <mat-tab label="Weight Estimator">
      <app-weight-estimator></app-weight-estimator>
    </mat-tab>
    <mat-tab label="Backups">
      <div class="admin-panel-backups">
        <h2>Backups <i class="backupsSize">{{backupsSize}}</i></h2>
        <div class="add-brand-grid">
          <mat-form-field class="example-form-field" appearance="fill">
            <mat-label>Create new backup</mat-label>
            <input matInput type="text" (input)="newBackupNameChange($event)" [(ngModel)]="newBackupName">
          </mat-form-field>

          <button [disabled]="allowCreateBackup === false" (click)="onBackupCreate()" mat-raised-button color="warn">Create</button>
        </div>

        <mat-card *ngIf="existDates.length" class="demo-inline-calendar-card">
          <mat-calendar [dateClass]="dateClass" [(selected)]="selected" (selectedChange)="onDateChanged($event)"></mat-calendar>
        </mat-card>
        <br>
        <div class="add-restore-grid">
          <mat-form-field appearance="fill">
            <mat-label>Select to restore</mat-label>
            <mat-select (selectionChange)="backupOnChange($event)" [disabled]="backupList.length === 0">
              <mat-option *ngFor="let backup of backupList" [value]="backup._id">
                {{backup.name}} - {{backup.created_at | date: 'h:mm:ss a'}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <button [disabled]="selectedBackup === null" (click)="onBackupRestore()" mat-raised-button color="warn">Restore</button>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Data Verification">
      <div class="admin-panel-data-verification">
        <h2>Data Verification Tools</h2>
        <p class="text-muted">Verify data integrity between database and external systems</p>

        <div class="verification-tools">
          <mat-card class="verification-card">
            <mat-card-header>
              <mat-card-title>
                <mat-icon>image</mat-icon>
                Image Sync Verification
              </mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <p>Check and sync product images between the database and Shopify stores.</p>
              <ul>
                <li>Find products with missing images in Shopify</li>
                <li>Detect image URL mismatches</li>
                <li>Bulk sync images to Shopify</li>
                <li>Support for both BHS and MWS stores</li>
              </ul>
            </mat-card-content>
            <mat-card-actions>
              <button (click)="goToImageSync()" mat-raised-button color="primary">
                <mat-icon>launch</mat-icon>
                Open Image Sync
              </button>
            </mat-card-actions>
          </mat-card>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>

</div>
